<template>
  <el-container id="app">
    <el-header
      v-if="
        this.$route.path !== '/showCustomForm' &&
        this.$route.path !== '/fillCustomForm'
      "
      style="height: 78px"
      :class="isHeadHide ? 'isHeadHide' : ''"
    >
      <div class="head-nav-block">
        <img
          @click="toHomePage"
          class="logo"
          src="./assets/img/toplogo.png"
          alt
        />
        <div class="head-menu-block" v-if="!verticalMenuBool">
          <el-menu
            @open="handleOpen"
            style="background: linear-gradient(to bottom, #c5dbf0, #c6dcea)"
            :default-active="activePath"
            class="el-menu-demo top-menu horizontal-menu-list"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <template v-for="item in navList">
              <el-menu-item
                v-if="item.children.length == 0"
                :key="item.path"
                :index="item.path"
              >
                <template>
                  <span class="cur-pointer">{{ item.name }}</span></template
                >
              </el-menu-item>

              <el-submenu
                v-else
                :index="item.path"
                :key="item.id"
                class="custom-submenu"
              >
                <template slot="title">
                  <span class="cur-pointer">{{ item.name }}</span>
                </template>

                <el-menu-item
                  v-for="subitem in item.children"
                  :key="subitem.path"
                  :index="subitem.path"
                  ><template>
                    <span slot="title" class="cur-pointer">{{
                      subitem.name
                    }}</span>
                  </template></el-menu-item
                >
              </el-submenu>
            </template>
          </el-menu>
        </div>

        <div class="toggle-menu-search-block">
          <div class="toggle-menu-icon" v-if="verticalMenuBool">
            <img
              width="100%"
              @click="toggeleMenuShow"
              height="100%"
              src="./assets/img/menu.png"
            />
          </div>
          <div class="search-block" v-if="showSearchBool">
            <form action="javascript:return true;">
              <el-input
                v-model="searchValue"
                placeholder="快捷搜索"
                class="search-input"
                ref="searchInput"
                @keyup.enter.native="quickSearch"
                @mouseenter.native="handleMouseEnterSearch"
                @mouseleave.native="handleMouseLeaveSearch"
                @blur="toggeleSearchShow"
              >
                <el-button
                  @click="quickSearch"
                  slot="append"
                  class="serach-button"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
            </form>
          </div>
          <div
            class="search-block-bool"
            @click="toggeleSearchShow"
            v-if="!showSearchBool"
          >
            <img width="100%" height="100%" src="./assets/img/search.jpg" />
          </div>
          <div
            class="search-block-bool"
            @click="toggeleSearchShow"
            v-if="showSearchBool"
          >
            <img
              width="100%"
              height="100%"
              src="./assets/img/hiddenSearch.jpg"
            />
          </div>
        </div>
        <div v-if="verticalMenuBool && toggeleMenuBool" class="head-menu-block">
          <el-menu
            @open="handleOpen"
            style="background: linear-gradient(to bottom, #c5dbf0, #c6dcea)"
            :default-active="activePath"
            :class="
              isHideMenu ? 'isHide' : 'el-menu-demo top-menu vertical-menu-list'
            "
            mode="vertical"
            @select="handleSelect"
            :router="router"
          >
            <template v-for="item in navList">
              <el-menu-item
                v-if="item.children.length == 0"
                :key="item.path"
                :index="item.path"
              >
                <template>
                  <span class="span cur-pointer">{{
                    item.name
                  }}</span></template
                >
              </el-menu-item>

              <el-submenu
                v-else
                :index="item.path"
                :key="item.id"
                class="custom-submenu"
              >
                <template slot="title">
                  <span class="cur-pointer">{{ item.name }}</span>
                </template>

                <el-menu-item
                  v-for="subitem in item.children"
                  :key="subitem.path"
                  :index="subitem.path"
                  ><template>
                    <span slot="title" class="cur-pointer">{{
                      subitem.name
                    }}</span>
                  </template></el-menu-item
                >
              </el-submenu>
            </template>
          </el-menu>
          <div class="search-vertical-block">
            <form action="javascript:return true;">
              <el-input
                v-model="searchValue"
                placeholder="快捷搜索"
                class="search-input"
                id="search-input"
                @focus="mobileSearchGetFocus"
                @keyup.enter.native="quickSearch"
                enter-button="搜索"
                type="search"
                ref="verticalSearchInput"
                @mouseenter.native="handleVertiMouseEnterSearch"
                @mouseleave.native="handleVertiMouseLeaveSearch"
                @blur="handlerVerticalMenuToggeleShow"
              >
                <el-button
                  @click="quickSearch"
                  slot="append"
                  class="serach-button"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
            </form>
          </div>
        </div>
      </div>
    </el-header>
    <el-main
      v-if="
        this.$route.path !== '/showCustomForm' &&
        this.$route.path !== '/fillCustomForm'
      "
      style="margin-top: 78px"
    >
      <router-view />
      <el-dialog
        title=""
        :visible.sync="dialogShareVisible"
        :width="shareDialogWidth"
        :modal="true"
        :lock-scroll="false"
        top="287px"

         class="share-dialog-box"
      >
        <div class="dialog-share-block">
          <div class="dialog-share-title">
            <span>分享至</span>
            <div class="share-line"></div>
          </div>
          <div class="dialog-share-content">
            <div class="share-item" @click="shareQQ">
              <div class="share-item-img">
                <img
                  width="100%"
                  height="100%"
                  src="../src/assets/img/shareQQ.png"
                  alt=""
                />
              </div>
              <div class="share-item-title"><span>QQ</span></div>
            </div>
            <div class="separation-line"></div>
            <div class="share-item" @click="shareQQSpace">
              <div class="share-item-img">
                <img
                  width="100%"
                  height="100%"
                  src="../src/assets/img/shareQQSpace.png"
                  alt=""
                />
              </div>
              <div class="share-item-title"><span>QQ空间</span></div>
            </div>
            <div class="separation-line"></div>
            <div class="share-item" @click="shareWeibo">
              <div class="share-item-img">
                <img
                  width="100%"
                  height="100%"
                  src="../src/assets/img/shareWeiBo.png"
                  alt=""
                />
              </div>
              <div class="share-item-title"><span>微博</span></div>
            </div>
          </div>
        </div>
      </el-dialog>
      <div class="online-sign-block">
        <div class="share-item" @click="onlineSign">
          <div class="share-item-img">
            <img
              width="100%"
              height="100%"
              src="../src/assets/img/onlineSignMini.jpg"
              alt=""
            />
          </div>
          <div class="share-item-title">
            <span>在线报名</span>
          </div>
        </div>
      </div>

      <div class="share-block">
        <div class="share-item" @click="onShare">
          <div class="share-item-img">
            <img
              width="100%"
              height="100%"
              src="../src/assets/img/shareMini.jpg"
              alt=""
            />
          </div>
          <div class="share-item-title">
            <span>分享</span>
          </div>
        </div>
      </div>
      <div class="to-top-block">
        <div class="share-item" @click="toTop">
          <div class="share-item-img">
            <img
              width="100%"
              height="100%"
              src="../src/assets/img/toTopMini.jpg"
              alt=""
            />
          </div>
          <div class="share-item-title">
            <span>顶部</span>
          </div>
        </div>
      </div>
    </el-main>
    <el-main
      v-if="
        this.$route.path == '/showCustomForm' ||
        this.$route.path == '/fillCustomForm'
      "
    >
      <router-view />
    </el-main>
    <el-footer
      v-if="
        this.$route.path !== '/showCustomForm' &&
        this.$route.path !== '/fillCustomForm'
      "
    >
      <div class="footer-block container">
        <div class="footer-text">
<!--          <div>-->
<!--            <span class="footer-block-info">访问人数：{{ visitLogCount }}</span>-->
<!--          </div>-->
          <div>
            <span class="footer-block-info"
              >{{ copyrightOne }}
              <a href="https://beian.miit.gov.cn/" target="_blank">{{
                osconfig.icpRecordNum
              }}</a></span
            >
          </div>
          <div>
            <span class="footer-block-info">{{ copyrightTwo }}</span>
          </div>
          <div>
            <span class="footer-block-info">{{ copyrightThree }} </span>
          </div>
          <div v-if="!mobilePhoneShow">
            <span class="footer-block-info">电话:{{ osconfig.phones }} </span>
          </div>
          <div v-for="(item, index) in osconfig.phoneArray" :key="index">
            <div v-if="mobilePhoneShow">
              <span class="footer-block-info-phone" v-if="index == 0">
                电话:{{ item }}</span
              >
              <span class="footer-block-info-phone" v-else>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item }}</span
              >
            </div>
          </div>
        </div>
        <div class="footer-icon">
          <div
            class="footer-icon-item"
            @mouseover="mouseOver"
            @mouseout="mouseLeave"
          >
            <div class="item-img-block">
              <img class="item-img" src="./assets/img/wechat.png" alt="" />
              <img
                v-if="showWeiXinQrCode"
                class="wechatQrCode"
                src="./assets/img/wechatQrCode.jpg"
                alt=""
              />
            </div>
            <span class="item-text">官方微信</span>
          </div>
        </div>
      </div>
    </el-footer>

    <!-- 悬浮菜单 -->
    <img   v-if="!toggeleMenuBool && mobilePhoneShow" @click="toggeleMenuShow" class="flot-img" src="./assets/img/menu.png" alt="">
  </el-container>
</template>

<script>
import {
  getFunctionListApi,
  addVisitLogApi,
  getVisitLogCountApi,
  osConfigListApi,
} from "./api/homeApi";
import shareMixin from "@/common/shareMixin";

export default {
  provide:[],
  components: {},
  data() {
    return {
      router: true,
      defaultActive: 1,
      verticalMenuBool: false,
      toggeleMenuBool: false,
      screenWidth: "",
      navList: [],
      showWeiXinQrCode: false,
      activePath: "",
      visitLogCount: 0,
      osconfig: {},
      mobilePhoneShow: false,
      isHeadHide: false,
      lastToTop: 0,
      searchValue: "",
      dialogShareVisible: false,
      showSearchBool: false,
      showSearchBlurBool: false,
      isHideMenu: false,
      showVertiSearchBlurBool: false,
      shareDialogWidth: "600px",
      isMobileMenuShow: false,
    };
  },
  mixins: [shareMixin],
  computed: {
    copyrightOne() {
      return this.osconfig.title + " ";
    },
    copyrightTwo() {
      return this.osconfig.copyright + " " + this.osconfig.hostUnit;
    },
    copyrightThree() {
      return "地址:" + this.osconfig.address;
    },
  },
  watch: {
    // 监听,当路由发生变化的时候执行
    $route: "getPath",
  },

  methods: {
    addMetaTag(name, content) {
      const meta = document.createElement("meta");
      meta.setAttribute("name", name);
      meta.setAttribute("content", content);
      document.head.appendChild(meta);
    },
    scrolling() {
      // 可视窗口顶部距离文档顶部的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 与上次滚动所更新的距顶值做对比，如果是小于0，说明这次对比上次的距顶小，说明用户正在往上滚动，反之则反
      let compareLast = scrollTop - this.lastToTop;
      this.lastToTop = scrollTop;
      if (compareLast > 0 && this.lastToTop > 60) {
        this.isHeadHide = true;
      } else {
        this.isHeadHide = false;
        this.isHideMenu = false;
        if (this.$refs.verticalSearchInput) {
          this.$refs.verticalSearchInput.blur();
        }
      }
    },
    shareQQ() {
      {
        var p = {
          url: window.location
            .href /*获取URL，可加上来自分享到QQ标识，方便统计*/,
          desc: "" /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/,
          title: this.osconfig.title /*分享标题(可选)*/,
          summary: "" /*分享描述(可选)*/,
          pics: "" /*分享图片(可选)*/,
          flash: "" /*视频地址(可选)*/,
          //commonClient : true, /*客户端嵌入标志*/
          site: "QQ分享" /*分享来源 (可选) ，如：QQ分享*/,
        };
        var s = [];
        for (var i in p) {
          s.push(i + "=" + encodeURIComponent(p[i] || ""));
        }
        var target_url =
          "http://connect.qq.com/widget/shareqq/iframe_index.html?" +
          s.join("&");
        window.open(target_url, "qq", "height=520, width=720");
      }
    },
    shareQQSpace() {
      // 分享的标题
      var _title = this.osconfig.title;
      var title = encodeURI(this.osconfig.title || document.title); // 分享内容链接
      var url = encodeURIComponent(url || window.location.href); // 分享图片的路径，多张图片以＂|＂隔开，可选参数
      var picurl = encodeURIComponent(picurl || ""); // 分享描述
      var content = encodeURIComponent(content || "");
      var shareqqzonestring =
        "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?summary=" +
        _title +
        "&desc=" +
        content +
        "&url=" +
        url +
        "&pics=" +
        picurl; // 在新窗口中打开
      window.open(shareqqzonestring, "_blank");
    },

    shareWeibo() {
      var currUrl = encodeURIComponent(window.location.href);
      window.open(
        "http://service.weibo.com/share/share.php?url=" +
          currUrl +
          "&title=" +
          this.osconfig.title +
          "&pics=" +
          "图片"
      );
    },
    toTop() {
      window.scrollTo(0, 0);
    },
    getPath() {
      this.activePath = this.$route.path;
      this.searchValue = this.$route.query.searchValue;
      if (this.$route.query.id) {
        if (this.$route.query.id == 2 || this.$route.query.id == 7) {
          this.activePath = this.$route.path;
        } else {
          this.activePath = this.$route.path + "?id=" + this.$route.query.id;
        }
      }

    },

    onlineSign() {
      // 跳转在线报名自定义表单
      this.$router.push({
        path: "/fillCustomForm?id=LUnHIKxpE6i7fu2RDgAw8A==",
      });
    },

    onShare() {
      this.dialogShareVisible = true;
    },

    handleSelect(path) {
      this.toggeleMenuBool = false;
      window.sessionStorage.setItem("activePath", path);
      this.activePath = path;
    },

    handleOpen(path, indexpath) {
      var tmpList = window.location.href.split("?");
      if (tmpList.length > 0) {
        this.activePath = tmpList[1];
      }
    },

    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      if (oWidth <= 1439) {
        this.verticalMenuBool = true;
      } else if (oWidth > 1439) {
        this.verticalMenuBool = false;
      }
      this.mobilePhoneShow = oWidth < 768 ? true : false;

      this.shareDialogWidth =  oWidth < 768? (oWidth - 30) + "px": "600px"

    },
    toggeleMenuShow() {
      this.toggeleMenuBool = !this.toggeleMenuBool;

      this.isMobileMenuShow = !this.isMobileMenuShow;

    },
    toggeleSearchShow() {
      if (this.showSearchBlurBool == false) {
        this.showSearchBool = !this.showSearchBool;
        if (this.showSearchBool == true) {
          this.$nextTick((_) => {
            this.$refs.searchInput.focus();
          });
        }
      }
    },
    handleMouseEnterSearch() {
      this.showSearchBlurBool = true;
    },
    handleMouseLeaveSearch() {
      this.showSearchBlurBool = false;
    },

    handleVertiMouseEnterSearch() {
      this.showVertiSearchBlurBool = true;
    },
    handleVertiMouseLeaveSearch() {
      this.showVertiSearchBlurBool = false;
    },

    handlerVerticalMenuToggeleShow() {
      if (this.showVertiSearchBlurBool == false) {
        this.isHideMenu = false;
      }
    },

    // 跳转并传递关键字
    quickSearch() {
      this.toggeleMenuBool = false;
      this.$router.push({
        path: "/searchAllData",
        query: { searchValue: this.searchValue },
      });
    },
    mobileSearchGetFocus() {
      this.isHideMenu = true;
    },

    mouseOver() {
      this.showWeiXinQrCode = true;
    },
    mouseLeave() {
      this.showWeiXinQrCode = false;
    },
    toHomePage() {
      this.$router.push({
        path: "/",
      });
    },
  },
  created: function () {
    this.handleResize();
    getFunctionListApi("").then((res) => {
      this.navList = res.data;
    });
    this.activePath = window.sessionStorage.getItem("activePath");
    addVisitLogApi();
    getVisitLogCountApi("").then((res) => {
      this.visitLogCount = res.data;
    });
    osConfigListApi().then((res) => {
      this.osconfig = res.data;
      this.osconfig.phoneArray = this.osconfig.phones.split("\n");
      var keywordsArray = this.osconfig.keyword.split(" ");
      keywordsArray.forEach((item) => {
        this.addMetaTag("keywords", item);
      });
      document.title = this.osconfig.title;
    });

  },

  mounted: function () {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.scrolling);
  },
};
</script>

<style lang="scss">
.el-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
}
* {
  padding: 0;
  margin: 0;
}

.el-main {
  padding: 0 !important;
}

.hidden {
  display: none;
}

.cur-pointer {
  cursor: pointer;
}

.el-header {
  height: 78px !important;
  padding: 0 !important;
  position: fixed;
  top: 0;
  transition: all 0.3s;
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.isHeadHide {
  top: -78px !important;
}
.isHide {
  display: none;
}
.el-menu-item {
  font-size: 16px !important;
  color: black !important;
  font-weight: bold;
}

/* 修改菜单激活项的背景颜色 */
.head-menu-block {
  .el-menu-item {
    .is-active {
      background-color: #254e75 !important;
      color: #fff !important;
      span {
        color: #fff !important;
      }
    }
  }
}
.el-menu--horizontal > .el-menu-item.is-active {
  background-color: #254e75 !important;
  color: #fff !important;
  span {
    color: #fff !important;
  }
}

.vertical-menu-list {
  z-index: 999 !important;
  .el-menu-item.is-active {
    background-color: #254e75 !important;
    color: #fff !important;
    span {
      color: #fff !important;
    }
  }
}

.head-nav-block {
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
  .logo {
    margin: 11px 22px 8px 13rem;
    height: 58px;
    width: 363px;
  }
  .head-menu-block {
    margin: 16px 0 12px 0;
    height: 50px;
    .horizontal-menu-list {
      border-bottom: 0px;
      .el-menu-item {
        height: 50px;
        padding: 0 13px;
        line-height: 50px;
        span {
          font-size: 16px;
          font-weight: 700;
          color: black;
        }
      }
    }
  }
  .toggle-menu-search-block {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .toggle-menu-icon {
      width: 40px;
      height: 40px;
      margin-top: 12px;
    }

    .search-block {
      margin: 20px 8px 8px 0;
      height: 50px;
      width: 260px;
    }
    .search-block-bool {
      margin: 12px 0px 10px 0;
      background-color: #c9daeb;
      height: 20px;
      width: 20px;
    }
  }

  .custom-submenu {
    .el-submenu__title {
      height: 50px !important;
      line-height: 50px !important;
      padding: 0 13px;
      span {
        font-size: 16px;
        font-weight: 700;
        color: black;
      }
      .el-menu-item {
        font-size: 16px;
        font-weight: 700;
        color: black;
      }
    }
  }
}
.el-menu--horizontal {
  .el-menu {
    width: 26rem;
    background-color: #fff;
    opacity: 0.8;
    padding: 10px;
    // margin-top: 12px;
    .el-menu-item {
      &:before {
        content: "";
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        background: black;
        vertical-align: middle;
        margin-right: 14px;
      }
      li {
        border-bottom: 1px dotted #254e75;
        span {
          font-weight: 700;
          font-size: 14px;
        }
      }
      &:hover {
        background: #255076;
        span {
          color: #fff;
        }
      }
    }
  }
}

.container {
  min-width: 1200px;
  margin: 0 12rem;
  box-sizing: border-box;
}

.el-menu-item {
  color: black !important;
  font-weight: bold;
}

.el-footer {
  padding: 0px !important;
  height: 188px;
}

.el-footer {
  background-color: #255076;
  min-height: 140px !important;
  height: auto !important;
  // margin-top: 20px;
  .footer-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    .footer-text {
      width: 600px;
      color: #fff;
      line-height: 24px;
      font-size: 12px;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      div {
        .footer-block-info-phone {
          width: 600px;
        }
      }
      a {
        color: #fff;
        line-height: 24px;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .footer-icon {
      display: flex;
      flex-direction: row;
      .footer-icon-item {
        display: flex;
        flex-direction: column;
        margin: 34px 40px 26px 0;
        height: 80px;
        width: 52px;
        .item-img-block {
          width: 52px;
          height: 52px;
          background-color: #fff;
          border-radius: 50%;
          position: relative;
          .item-img {
            margin: 11px;
            width: 30px;
            height: 30px;
          }
          .wechatQrCode {
            position: absolute;
            width: 100px;
            height: 100px;
            right: -20px;
            bottom: 60px;
          }
        }
        span {
          height: 24px;
          font-size: 12px;
          font-weight: 600;
          width: 52px;
          margin-top: 4px;
          color: #fff;
          line-height: 24px;
        }
      }
    }
  }
}

.online-sign-block,
.share-block,
.to-top-block {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 0;
  z-index: 999;
  box-sizing: border-box;
  .share-item {
    width: 60px;
    height: 60px;
    display: flex;
    flex-direction: column;
    background-color: #215279;
    &:hover {
      .share-item-title {
        // color: #0e517a;
      }
    }
    .share-item-img {
      width: 40px;
      height: 40px;
      margin: 0 10px;
    }
    .share-item-title {
      width: 60px;
      height: 12px;
      font-size: 12px;
      font-weight: 500;
      line-height: 12px;
      text-align: center;
      margin-top: 2px;
      color: #fff;
    }
  }
}

.to-top-block {
  bottom: 103px;
  .share-item {
    background-color: #999999;
  }
}

.share-block {
  bottom: 173px;
}

.online-sign-block {
  bottom: 243px;
}


.share-dialog-box{

  .el-dialog__header{
    .el-dialog__headerbtn{
      font-size: 20px;
    }

  }

  .el-dialog__body{
    padding: 4px 0 0 0 ;
  }

}

.dialog-share-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 254px;



  .dialog-share-title {
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    letter-spacing: 0em;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #3D3D3D;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .share-line {
      margin-top: 18px;
      background-color: #245075;
      height: 2px;
      width: 41px;
    }
  }
  .dialog-share-content {
    margin-top: 49px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    width: 100%;
    .share-item {
      width: 32%;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .share-item-img {
        width: 24px;
        height: 24px;
      }
      .share-item-title {
        margin-top: 10px;
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        text-align: center;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        /* 主标题 */
        color: #050D33;
      }
    }
    :hover {
      background-color: #c5dbf0;
    }
    .separation-line {
      width: 1px;
      height: 100px;
      background-color: #d8d8d8;
    }
  }
}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
  .head-nav-block {
    .toggle-menu-search-block {
      .search-block {
        width: 160px;
      }
      .search-block-bool {
      }
    }
  }
  .el-header {
    width: 100%;
    height: 150px;
    padding: 25px 100px;
    z-index: 10;
  }

  .head-nav-block {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
    .logo {
      margin: 11px 22px 9px 13rem;
      height: 58px;
    }
    .head-menu-block {
      margin: 16px 0 12px 0;
      height: 50px;
      .horizontal-menu-list {
        border-bottom: 0px;
        .el-menu-item {
          height: 50px;
          padding: 0 13px;
          line-height: 50px;
          span {
            font-size: 16px;
            font-weight: 700;
            color: black;
          }
        }
      }
    }
    .custom-submenu {
      .el-submenu__title {
        height: 50px !important;
        line-height: 50px !important;
        padding: 0 13px;
        span {
          font-size: 16px;
          font-weight: 700;
          color: black;
        }
        .el-menu-item {
          font-size: 16px;
          font-weight: 700;
          color: black;
        }
      }
    }
  }

  .container {
    min-width: 0;
  }

  .el-menu-item {
    color: black !important;
    font-weight: bold;
  }

  .el-footer {
    padding: 0px !important;
    height: 188px;
  }

  .toggle-menu-icon {
    width: 40px;
    height: 40px;
    margin-top: 16px;
  }

  .el-footer {
    background-color: #255076;
    min-height: 140px !important;
    .footer-block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .footer-text {
        color: #fff;
        line-height: 24px;
        font-size: 12px;
        font-weight: 400;
        span {
          min-height: 24px;
        }
      }
      .footer-icon {
        display: flex;
        flex-direction: row;
        .footer-icon-item {
          display: flex;
          flex-direction: column;
          margin: 34px 40px 26px 0;
          height: 80px;
          width: 52px;
          .item-img-block {
            width: 52px;
            height: 52px;
            background-color: #fff;
            border-radius: 50%;
            position: relative;
            .item-img {
              margin: 11px;
              width: 30px;
              height: 30px;
            }
            .wechatQrCode {
              position: absolute;
              width: 100px;
              height: 100px;
              right: -20px;
              bottom: 60px;
            }
          }
          span {
            height: 24px;
            font-size: 12px;
            font-weight: 600;
            width: 52px;
            margin-top: 4px;
            color: #fff;
            line-height: 24px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1600px) {
  .head-nav-block {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    justify-content: flex-start;
    background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
    .logo {
      margin: 11px 22px 8px 4rem;
    }
    .head-menu-block {
      margin: 16px 0 12px 0;
      height: 50px;
      .horizontal-menu-list {
        border-bottom: 0px;
        .el-menu-item {
          height: 50px;
          padding: 0 13px;
          line-height: 50px;
          span {
            font-size: 16px;
            font-weight: 700;
            color: black;
          }
        }
      }
    }
    .toggle-menu-icon {
      margin-right: 120px;
      width: 50px;
    }
  }
}
@media only screen and (max-width: 1439px) {
  .head-nav-block {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
    .logo {
      margin: 11px 22px 8px 14rem;
    }
    .head-menu-block {
      height: 50px;
      width: 100%;
      margin: 0;
      .vertical-menu-list {
        width: 100%;
        border-bottom: 0px;
        .el-menu-item {
          height: 50px;
          width: 100%;
          line-height: 50px;
          span {
            font-size: 16px;
            font-weight: 700;
            color: black;
          }
        }
      }
      .search-vertical-block {
        background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
        width: 100%;
        height: 60px;
        .search-input {
          width: 60%;
          margin-left: 20%;
          padding-right: 100px;
        }
      }
    }
    .toggle-menu-search-block {
      .toggle-menu-icon {
        margin-top: 8px;
        margin-right: 40px;
      }

      .search-block-bool {
        margin: 12px 60px 10px 0;
        background-color: #c9daeb;
        height: 20px;
        width: 20px;
      }
    }
  }
}
@media only screen and (max-width: 1330px) {
  .head-nav-block {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
    .logo {
      margin: 11px 22px 8px 12rem;
      //
    }
    .head-menu-block {
      height: 50px;
      width: 100%;
      margin: 0;
      .vertical-menu-list {
        width: 100%;
        border-bottom: 0px;
        .el-menu-item {
          height: 50px;
          width: 100%;
          line-height: 50px;
          span {
            font-size: 16px;
            font-weight: 700;
            color: black;
          }
        }
      }
      .search-vertical-block {
        background: linear-gradient(to bottom, #c5dbf0, #c6dcea);
        width: 100%;
        height: 60px;
        .search-input {
          width: 60%;
          margin-left: 20%;
        }
      }
    }
    .toggle-menu-search-block {
      .toggle-menu-icon {
        margin-top: 8px;
        margin-right: 40px;
      }

      .search-block-bool {
        margin: 12px 60px 10px 0;
        background-color: #c9daeb;
        height: 20px;
        width: 20px;
      }
    }
  }
  .el-footer {
    .footer-block {
      .footer-text {
        margin-left: 20px;
      }
      .footer-icon {
        display: flex;
        flex-direction: row;
        .footer-icon-item {
          display: flex;
          flex-direction: column;
          margin: 34px 40px 26px 0;
          height: 80px;
          width: 52px;
          .item-img-block {
            width: 52px;
            height: 52px;
            background-color: #fff;
            border-radius: 50%;
            position: relative;
            .item-img {
              margin: 11px;
              width: 30px;
              height: 30px;
            }
            .wechatQrCode {
              position: absolute;
              width: 100px;
              height: 100px;
              right: -20px;
              bottom: 60px;
            }
          }
          span {
            height: 24px;
            font-size: 12px;
            font-weight: 600;
            width: 52px;
            margin-top: 4px;
            color: #fff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
}

@media only screen and (max-width: 992px) {
  .head-nav-block {
    .toggle-menu-search-block {
      .search-block {
        display: none;
      }
      .search-block-bool {
        display: none;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }

  .head-nav-block {
    padding-left: 0px;
    .logo {
      margin: 17px 0px 13px 6rem;
      width: 273.5px;
      height: 44px;
    }
    .toggle-menu-search-block {
      .toggle-menu-icon {
        margin: 0px 10px 0 0;
        width: 30px;
        height: 30px;
      }
    }
  }
  .container {
    min-width: 0;
    margin: 0 40px;
  }

  .el-footer {
    height: 140px;
    .footer-block {
      display: flex;
      justify-content: start;
      align-items: center;
      .footer-text {
        width: 600px;
        color: #fff;
        line-height: 24px;
        font-size: 12px;
        font-weight: 400;
      }
      .footer-icon {
        display: none;
      }
    }
  }

  .share-block,
  .online-sign-block,
  .to-top-block {
    display: none;
  }

  .flot-img{
    width: 36px;
    height: 36px;
    border-radius: 4px;
    position: fixed;
    right: 10px;
    bottom: 120px;
    z-index: 9999999;
    background-color: #fff;
    box-shadow: 0px 0px 21px 3px #f1f1f1;
  }

}
@media only screen and (max-width: 400px) {
  .head-nav-block {
    .logo {
      margin: 19.75px 0px 19.75px 12rem;
      width: 248px;
      height: auto !important;
    }
    .toggle-menu-search-block {
      .toggle-menu-icon {
        margin: 0px 12px 0 0;
        width: 30px;
        height: 30px;
      }
    }
  }

  .el-footer {
    .footer-block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 140px;
      .footer-text {
        width: 402px;
        color: #fff;
        line-height: 24px;
        font-size: 12px;
        font-weight: 400;
        /*height: 192px;*/
      }
    }
  }

  .flot-img{
    width: 36px;
    height: 36px;
    position: fixed;
    right: 10px;
    bottom: 120px;
    z-index: 999999;
  }

}
</style>
